import React, { useState } from 'react';
import styled from 'styled-components';
import { func, bool, string } from 'prop-types';

const Login = ({ handleLogin, loading, error }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  return (
    <Container>
      <Title>SpeedVacanze</Title>

      <HelperText>
        {loading && <p>Loading...</p>}
        {error && !loading && <Error>{error}</Error>}
      </HelperText>

      <InnerContainer
          onSubmit={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handleLogin(username, password);
          }}
      >
        <div>
          <Input
            type="text"
            placeholder="Username"
            value={username}
            onChange={({ target }) => setUsername(target.value)}
            autoFocus={!username}
            autoCapitalize="off"
            autoCorrect="off"
            required
          />
        </div>

        <div>
          <Input
            placeholder="Password"
            value={password}
            onChange={({ target }) => setPassword(target.value)}
            autoFocus={username}
            type="password"
            required
          />
        </div>

        <Button
          type="submit"
          disabled={loading}
        >
          Accedi
        </Button>
      </InnerContainer>
    </Container>
  );
};

Login.propTypes = {
  handleLogin: func.isRequired,
  loading: bool,
  error: string,
};

export default Login;

const Container = styled.div`
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background-color: #f2f6fa;
  min-height: 100vh;
`;
const Title = styled.div`
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
  color: #7a7a7a;
`;

const HelperText = styled.div`
  height: 50px;
`;

const Error = styled.p`
  color: red;
`;

const InnerContainer = styled.form`
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 3px rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 10%);
  color: #4a4a4a;
  padding: 1.25rem;
`;

const Input = styled.input`
  background-color: #fff;
  border: 1px solid ${({ error }) => (error ? '#ff3860' : '#dbdbdb')};
  color: #363636;
  border-radius: 4px;
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  padding: 9px 8px;
  width: 100%;
  box-sizing: border-box;

  font-size: 26px;
  margin-bottom: 20px;

  ::placeholder {
    color: #d6d6d6;
  }
`;

const Button = styled.button`
  background-color: #ffdd57;
  border-color: transparent;
  color: rgba(0, 0, 0, 0.7);
  width: 100%;
  padding: 12px;
  font-size: 22px;
  border-radius: 4px;
  margin-top: 16px;
  cursor: pointer;

  ${({ disabled }) => disabled && 'pointer-events: none;'}
`;
